import {
  importProvidersFrom,
  inject,
  NgModule,
  provideEnvironmentInitializer,
} from '@angular/core';
import { APP_BASE_HREF, CommonModule } from '@angular/common';
import { AppComponent } from './app.component';

import { AppRoutingModule } from './app-routing.module';
import { CoreModule } from './core/core.module';
import { NgbDateParserFormatter, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { CustomDateParserFormatterService } from './shared/ui-components/inline-datepicker/custom-date-parser-formatter.service';
import { environment } from '../environments/environment';
import { LoggerModule } from 'ngx-logger';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { SharedModule } from '@share/shared.module';
import { ApiModule } from '@openapi/api.module';
import { ApiConfiguration } from './core/api-configuration';
import { DevToolsService } from './core/services/dev-tools.service';
import { TranslateModule } from '@ngx-translate/core';
import { IconRegistryService } from './core/services/icon-registry.service';
import { provideNativeDateAdapter } from '@angular/material/core';

@NgModule({
  declarations: [AppComponent],
  imports: [
    NgbModule,
    BrowserAnimationsModule,
    CommonModule,
    CoreModule,
    AppRoutingModule,
    SharedModule,
    ApiModule.forRoot(
      () => new ApiConfiguration({ basePath: environment.apiBasePath }),
    ),
  ],
  providers: [
    {
      provide: NgbDateParserFormatter,
      useClass: CustomDateParserFormatterService,
    },
    { provide: APP_BASE_HREF, useValue: environment.baseHref },
    importProvidersFrom(
      LoggerModule.forRoot({
        serverLoggingUrl: 'api/logs',
        level: environment.loggingLevel,
        serverLogLevel: environment.serverLoggingLevel,
      }),
    ),
    // Required so pe-dynamic-forms components can resolve TranslateService at the root injector.
    importProvidersFrom(TranslateModule.forRoot()),
    provideNativeDateAdapter(),
    provideAnimationsAsync(),
    provideEnvironmentInitializer(() => {
      const iconRegistry = inject(IconRegistryService);
      inject(DevToolsService);
      iconRegistry.registerIcons();
    }),
  ],
  bootstrap: [AppComponent],
})
export class AppModule {}
